import { motion } from "framer-motion";
import { Film, Megaphone, Youtube, Rocket } from "lucide-react";

const PATHS = [
  {
    n: "01", icon: Film, title: "Film & Series",
    roles: "DIRECTOR · PRODUCER · DOP · EDITOR",
    text: "Step into the film industry — feature films, series and documentaries, in the roles our pipeline trains you for.",
  },
  {
    n: "02", icon: Megaphone, title: "Advertising & Brands",
    roles: "PROMOS · BRAND FILMS · SOCIAL SPOTS",
    text: "Join a video advertising agency and make promotional content for businesses — exactly what LIM does daily.",
  },
  {
    n: "03", icon: Youtube, title: "Full-Time Creator",
    roles: "YOUTUBE · REELS · YOUR OWN CHANNEL",
    text: "Build your own audience with production-grade content — strategy, shooting and editing all in-house: you.",
  },
  {
    n: "04", icon: Rocket, title: "Freelance & Founder",
    roles: "FREELANCE · OWN AGENCY · OWN STUDIO",
    text: "Shoot or edit independently — or go further and start your own agency or studio, the way Life Inside Media began.",
  },
];

export default function CareerPathsSection() {
  return (
    <section className="bg-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-white/10" data-testid="career-paths-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-20">
        <div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-lima-paper leading-[0.98]">
            Train once.
            <br />
            <span className="font-serifit font-normal text-lima-blue">Work anywhere.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm md:text-base text-white/50 leading-relaxed">
          The pipeline you learn at LIMA is the same one four different careers run on. Pick a lane — or invent your own.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {PATHS.map((p, i) => (
          <motion.article
            key={p.n}
            initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="bg-lima-ink p-7 md:p-9 flex flex-col group hover:bg-lima-surface transition-colors duration-300"
            data-testid={`career-path-${p.n}`}
          >
            <div className="flex items-start justify-between mb-10">
              <span className="font-serifd text-4xl text-lima-blue leading-none">{p.n}</span>
              <span className="w-11 h-11 grid place-items-center border border-lima-blue/40 text-lima-blue group-hover:bg-lima-blue group-hover:text-white transition-colors duration-300">
                <p.icon size={18} />
              </span>
            </div>
            <h3 className="font-display font-bold text-2xl tracking-tight text-lima-paper">{p.title}</h3>
            <p className="mt-2 font-mono2 text-[11px] tracking-[0.15em] text-[#6B73FF] leading-relaxed">{p.roles}</p>
            <p className="mt-4 text-sm text-white/55 leading-relaxed">{p.text}</p>
          </motion.article>
        ))}
      </div>
      <p className="mt-8 font-mono2 text-[11px] tracking-[0.15em] text-white/40">
        AND THE PATH YOU INVENT — SEVERAL LIM ALUMNI GO ON TO START STUDIOS OF THEIR OWN.
      </p>
    </section>
  );
}
